/**
 * A grid of `count` cells, `cols` across, each `aspect` times as tall as it
 * is wide, as big as fits `width` and `maxHeight` (at most `max` across).
 * A short last row sits in the middle. Returns each cell's centre and the
 * cell size.
 */
export function gridCells(count: number, cols: number, width: number, max: number, gap = 8, aspect = 1, maxHeight = Infinity) {
  const rows = Math.ceil(count / cols);
  const byWidth = (width - gap * (cols - 1)) / cols;
  const byHeight = (maxHeight - gap * (rows - 1)) / rows / aspect;
  const size = Math.max(24, Math.floor(Math.min(max, byWidth, byHeight)));
  const h = Math.round(size * aspect);
  const cells = Array.from({ length: count }, (_, i) => {
    const row = Math.floor(i / cols);
    const inRow = Math.min(cols, count - row * cols);
    const rowW = inRow * size + (inRow - 1) * gap;
    const left = (width - rowW) / 2;
    return { x: left + (i % cols) * (size + gap) + size / 2, y: row * (h + gap) + h / 2 };
  });
  return { cells, size, h, height: rows * h + (rows - 1) * gap };
}

/** How many across for `count` cards: rows of 4, or of 5 when that fills
 *  them better (10 cards are two rows of 5, not 4, 4 and 2). */
export function columnsFor(count: number): number {
  if (count % 4 === 0 || count <= 4) return Math.min(4, Math.max(1, count));
  if (count % 5 === 0) return 5;
  return count % 3 === 0 ? 3 : 4;
}
